import { render, staticRenderFns } from "./graduationWj.vue?vue&type=template&id=aac1593c&scoped=true"
import script from "./graduationWj.vue?vue&type=script&lang=js"
export * from "./graduationWj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac1593c",
  null
  
)

export default component.exports